import React, { useState } from "react";

import { Button, MenuItem, Select, Stack, Switch, Typography } from "@mui/material";
import { useNumberFormatSelector, useUserActions } from "store";

interface Props {
  close: () => void;
}

export const FormContent: React.FC<Props> = ({ close }) => {
  const { abbreviated, decimal } = useNumberFormatSelector();
  const { updateNumberFormatAction } = useUserActions();

  const [abbreviatedState, setAbbreviatedState] = useState<boolean>(abbreviated);
  const [decimalState, setDecimalState] = useState<number>(decimal);

  const handleSubmit = () => {
    updateNumberFormatAction({ abbreviated: abbreviatedState, decimal: decimalState });
    close();
  };

  return (
    <Stack sx={{ padding: "30px", borderRadius: "8px" }} gap="20px">
      <Typography sx={{ fontSize: "18px" }}>Number Format</Typography>
      <Stack gap="10px">
        <Stack flexDirection="row" alignItems="center" gap="10px">
          <Stack>
            <Typography>Abbreviated Number Format</Typography>
            <Typography sx={{ color: "#92A7BC", fontSize: "14px" }}>{"(Billion / Million / Thousand)"}</Typography>
          </Stack>
          <Switch
            focusVisibleClassName=".Mui-focusVisible"
            checked={abbreviatedState}
            onChange={() =>
              setAbbreviatedState((prev) => {
                return !prev;
              })
            }
            sx={{
              width: 48,
              height: 24,
              padding: 0,
              "& .MuiSwitch-switchBase": {
                padding: 0,
                margin: "2px",
                transitionDuration: "300ms",
                color: "#bac7ce",
                "&.Mui-checked": {
                  transform: "translateX(23px)",
                  color: "#0a3142",
                  "& + .MuiSwitch-track": {
                    backgroundColor: "#dae0e2",
                    opacity: 1,
                    border: 0
                  },
                  "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5
                  }
                },
                "&.Mui-focusVisible .MuiSwitch-thumb": {
                  color: "#33cf4d",
                  border: "6px solid #fff"
                },
                "&.Mui-disabled .MuiSwitch-thumb": {
                  opacity: 0.7
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                  opacity: 0.3
                }
              },
              "& .MuiSwitch-thumb": {
                boxSizing: "border-box",
                width: 20,
                height: 20
              },
              "& .MuiSwitch-track": {
                borderRadius: "34px",
                backgroundColor: "#dae0e2",
                opacity: 1,
                transition: "background-color 500ms"
              }
            }}
          />
        </Stack>
        <Stack flexDirection="row" alignItems="center" gap="10px">
          <Typography>Decimal Places</Typography>
          <Select
            sx={{
              width: "140px",
              height: "32px",
              padding: "0px",
              ".MuiSelect-select": {
                padding: "6px"
              },
              "& > fieldset": { borderColor: "rgba(123, 146, 169, 1)", borderRadius: "10px" }
            }}
            value={decimalState}
            onChange={(e) => setDecimalState(Number(e.target.value))}
          >
            {[0, 1, 2, 3, 4, 5, 6].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      </Stack>
      <Stack flexDirection="row" justifyContent="flex-end" gap="20px">
        <Button variant="outlined" onClick={close}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit}>
          Apply
        </Button>
      </Stack>
    </Stack>
  );
};
